import Api from '@/services/Api'

export default {
  suggestAlbums () {
    return Api().get('albums/suggest')
  },
  searchAlbums (query) {
    return Api().get('search/albums', {params: {q: query}})
  }
}



// WEBPACK FOOTER //
// ./src/services/AlbumsService.js